<template>
  <div class="pdf" 
    v-loading="loadding" 
    element-loading-text="加载中"
    element-loading-spinner="el-icon-loading">
    <!-- <iframe :src="url" frameborder="0" width="100%" height="100%"></iframe> -->
    <canvas class="first-area" v-for="page in pages" :id="'the-canvas'+page" :key="page"></canvas>
  </div>
</template>

<script>
import Vue from 'vue';
import PDFJS from 'pdfjs-dist'
export default {
  data () {
    return {
      titleBar: '',
      pdfDoc: null,
      loadding: false,
      pages: 0,
      url:'',
    }
  },
  methods: {
    renderPage (num) {
 
      let _this = this;
      this.pdfDoc.getPage(num).then(function (page) {
        let canvas = document.getElementById('the-canvas' + num)
        let ctx = canvas.getContext('2d')
        let dpr = window.devicePixelRatio || 1
        let bsr = ctx.webkitBackingStorePixelRatio ||
                  ctx.mozBackingStorePixelRatio ||
                  ctx.msBackingStorePixelRatio ||
                  ctx.oBackingStorePixelRatio ||
                  ctx.backingStorePixelRatio || 1
        let ratio = dpr / bsr
        let w=document.getElementsByClassName('pdf')[0].clientWidth
        var viewport = page.getViewport(w / page.getViewport(1).width)
        canvas.width = viewport.width * ratio
        canvas.height = viewport.height * ratio
        canvas.style.width = viewport.width + 'px'
        canvas.style.height = viewport.height + 'px'
        ctx.setTransform(ratio, 0, 0, ratio, 0, 0)
        // ctx.translate(canvas.width/2,canvas.height/2)
        // ctx.rotate(180 * Math.PI / 180)
        // ctx.scale(-1, 1)
        // ctx.translate(-canvas.width/2,0)
        var renderContext = {
          canvasContext: ctx,
          viewport: viewport
        }
        page.render(renderContext)
        if (_this.pages > num) {
          _this.renderPage(num + 1)
          console.log(num + 1)
        }else{
          _this.loadding=false
        }
        _this.$emit('scroll')
      }).catch()
    },
    loadFile (url) {
      let _this = this
      let params={
        url:url,
        cMapPacked : true,
        cMapUrl:'https://unpkg.com/pdfjs-dist@2.0.943/cmaps/'
      }
      PDFJS.getDocument(params).then(function (pdf) {
        _this.pdfDoc = pdf
        _this.pages = _this.pdfDoc.numPages
        _this.$nextTick(() => {
          _this.renderPage(1)
        })
      }).catch()
    }
  },
  props:{
    pdfUrl:{
      type:String,
      default:''
    }
  },
  mounted () {
    console.log(this.pdfUrl)
    this.loadding=true
    this.loadFile(this.pdfUrl)
  },
}
</script>

<style scoped>
canvas {
  display: block;
  /* border-bottom: 1px solid black; */
}
.pdf{
  /* padding-top:80px;
  height: 100vh; */
  min-height: 65vh;
}
.pdf >>> .van-icon-arrow-left{
  color: #aaa
} 
.btn{
  width:100%
}
</style>



// WEBPACK FOOTER //
// src/pages/infoCollection/components/pdf.vue